module.exports = __webpack_public_path__ + "img/hex_dec_corresponding.a2b9a7ab.png";